import { z } from 'zod';

export interface BranchSettingsApi {
  id: string;
  branchId: string;
  key: string;
  value: string;
  longValue?: string;
  numberValue?: number;
  dateValue?: string;
  createdAt: string;
  updatedAt: string;
}

export interface BranchSettings {
  id: string;
  branchId: string;
  key: string;
  value: string;
  longValue?: string;
  numberValue?: number;
  dateValue?: string;
  createdAt: string;
  updatedAt: string;
}

export interface NewBranchSettings {
  key: string;
  value: string;
  longValue?: string;
  branchId: string;
  dateValue?: string;
  numberValue?: number;
}

export interface CreateBranchSettingsPayload {
  branchId: string;
  key: string;
  value: string;
  longValue?: string;
  numberValue?: number;
  dateValue?: string;
}

export interface UpdateBranchSettingsPayload {
  key?: string;
  value?: string;
  longValue?: string;
  numberValue?: number;
  dateValue?: string;
  branchId?: string;
}

export interface BranchSettingsFilters {
  key?: string;
  value?: string;
}

export const branchSettingsSchema = z.object({
  key: z
    .string()
    .min(1, 'La clave es requerida')
    .max(100, 'La clave no puede exceder 100 caracteres')
    .regex(
      /^[a-zA-Z0-9_]+$/,
      'La clave solo puede contener letras, números y guiones bajos'
    ),
  value: z
    .string()
    .min(1, 'El valor es requerido')
    .max(255, 'El valor no puede exceder 255 caracteres'),
  longValue: z
    .string()
    .max(1000, 'El valor largo no puede exceder 1000 caracteres')
    .optional()
    .or(z.literal('')),
  branchId: z.string().min(1, 'La sucursal es requerida'),
  dateValue: z
    .union([z.string(), z.date()])
    .optional()
    .transform((val) => {
      if (val === '' || val === undefined || val === null) {
        return undefined;
      }
      if (val instanceof Date) {
        return val.toISOString();
      }
      return val;
    }),
  numberValue: z
    .union([z.string(), z.number()])
    .optional()
    .transform((val) => {
      if (val === '' || val === undefined || val === null) {
        return undefined;
      }
      const num = typeof val === 'string' ? parseFloat(val) : val;
      return isNaN(num) ? undefined : num;
    })
    .refine((val) => val === undefined || val >= 0, {
      message: 'El valor numérico debe ser mayor o igual a 0',
    }),
});

export const updateBranchSettingsSchema = branchSettingsSchema.partial().omit({
  branchId: true,
});

export const createBranchSettingsFormSchema = branchSettingsSchema.omit({
  branchId: true,
});

export type BranchSettingsSchema = z.infer<typeof branchSettingsSchema>;
export type UpdateBranchSettingsSchema = z.infer<
  typeof updateBranchSettingsSchema
>;
export type CreateBranchSettingsFormSchema = z.infer<
  typeof createBranchSettingsFormSchema
>;

export const defaultBranchSettingsValues: BranchSettingsSchema = {
  key: '',
  value: '',
  longValue: '',
  branchId: '',
  dateValue: '',
  numberValue: undefined,
};

export const defaultCreateBranchSettingsFormValues: CreateBranchSettingsFormSchema =
  {
    key: '',
    value: '',
    longValue: '',
    dateValue: '',
    numberValue: undefined,
  };
